import * as React from 'react';
import { HeadingProps } from '../../../Heading';

export interface HeaderProps {
  children?: React.ReactNode;
  className?: string;
  dataHook?: string;
  title?: React.ReactNode;
  titleSize?: HeadingProps['size'];
  titleTag?: HeadingProps['as'];
  subtitle?: React.ReactNode;
  showHeaderDivider?: boolean;
}

export declare const Header: React.FunctionComponent<HeaderProps> & {
  Title: React.FunctionComponent<{ children?: React.ReactNode }>;
};
